import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { NavController, NavParams, LoadingController, ModalController} from 'ionic-angular';
import { LotteryService, SharedService, gamerule, selection, BetPanel, numberType, errorHelper, LottoBetpanelService, draw} from 'baseline-lib';
import { PrizeLevelModalPage } from '../prize-level-modal/prize-level-modal';
import { Global } from '../../../global/global';
import { WebviewpagesPage } from '../../shared/webviewpages/webviewpages';
import { BetslipPage } from '../betslip/betslip';
import { LotteryMenuPage } from '../lottery-menu-page/lottery-menu-page';
import { CustomToast } from '../../shared/services/custom-toast';


/**
 * Generated class for the LotteryDetailPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-lottery-detail',
  templateUrl: 'lottery-detail.html',
})
export class LotteryDetailPage implements OnInit{
  @Input() _gameid : number;
  numberlist : any;
  grid=[];
  noOfColsPerRow = 8;
  _gameRule?: gamerule;
  drawsub: any;
  drawex: number;
  prizelevelsub: any;
  iscombination_bet : boolean = false;
  flag: boolean;
  ismenuvisible:boolean = false;
  error?: errorHelper;
  public bet_type;
  public bet_type_single;
  counter : number = 0; // to add margin top on menu click
  drawResult: any;
  drawViewerList: draw[];
  drawResultForViewTimer: any;
  userStatus: any;
  showprofile : boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, 
    private _lotteryService: LotteryService, public _sharedService: SharedService,
    public loadingCtrl: LoadingController, public _lottoBetpanelService: LottoBetpanelService,
    private toast: CustomToast, public modalCtrl: ModalController, public globalData:Global) {
    
    //  this._gameid = navParams.get('_gameid');
      this.drawViewerList = [];

  }
  
   bettypeChange(bettype,data) {
     
     console.log("bettype",bettype);
     if(data=='bettypesingle'){
      bettype=this._gameRule.bli[0]
     }
     if(data == 'bettype'){
    for(var i=0;i<this._gameRule.bli.length;i++){

      if(this._gameRule.bli[i].bid == bettype){
        bettype = this._gameRule.bli[i]
      }
    }} try {
      this._gameRule.changeBettype(bettype);
      if('isBankerSel' in this._gameRule.selectedBettype){
      this.iscombination_bet = this._gameRule.selectedBettype.isBankerSel;
      }else{
        this.iscombination_bet = false;
      }
    }
    catch (err) {
     this.error.show = true;
      this.error.message = err.message;
    }
  }

  drawChange(did:any) {
    this._gameRule.draws.forEach(element => {

      element.isSelected = false;

      if (element.did == did) {
        this.drawex=did;
        element.isSelected = true;
      }

    })
  }

  refreshDrawList() {
    // this._gameRule.filterDraws(this._sharedService.getServerTime());
    this.drawResult = null;
    this.destroyTimer();
    var data = this._gameRule.draws.find(a => a.isCurrent);
    this._gameRule.filterDraws(this._sharedService.getServerTime());
    this.drawViewerList.push(data);

    if (this._gameRule.isRapid) {
      this.drawResult = -9;
      setTimeout(() => {
        this._sharedService.getDrawResultDrawKId(this.drawViewerList[this.drawViewerList.length - 1]).subscribe(data => {
          if (data.id) {
            this.drawResult = data;
            // var authuser = this._sharedService._sessionService.getAuthUser();
            // if(authuser)  
              //this.mybetComp.getmybetsDrawResult(this._gameid);                        
            setTimeout(() => {                     
              setTimeout(() => {  
                this.userStatus = '';                                  
                this.drawResult = null;                                               
              }, 5000);                                        
            }, this.drawResult.rno.length > 6 ? 30000 : 10000);
          }
          else {
            this.drawResult = null;
          }
        })
      },20000);
    }
  }

  
  destroyTimer() {
    if (this.drawResultForViewTimer) {
      clearInterval(this.drawResultForViewTimer);
      this.drawResultForViewTimer = null;
    }
  }

  howtoplay() {
    
    let profileModal = this.modalCtrl.create(WebviewpagesPage, { url: this._gameRule.spe.hpli });
    profileModal.present();
  }

  presentProfileModal() {
    let profileModal = this.modalCtrl.create(PrizeLevelModalPage, { prizedata: this._gameRule.pll });
    profileModal.present();
  }
  
  autopick() {
    try {
      this._gameRule.autopick();
    }
    catch (err) {
      this.error.show = true;
      this.error.message = err.message;
    }
  }

    //reset to selection.
     reset() {
      try {
        if (this._gameRule)
          this._gameRule.reset();
          if(this._gameRule.selectedBettype && this._gameRule.selectedBettype != undefined){
            this._gameRule.selectedBettype = undefined;
          }
          this._gameRule;
          this.bet_type = null;     
          this.bet_type_single = null;
      }
      catch (err) {
        this.error.show = true;
        this.error.message = err.message;
      }
  
    }

    openBetSlipPage()
    {   
      this.navCtrl.push(BetslipPage)
    }

    openLotteryMenuPage(){
      this.navCtrl.push(LotteryMenuPage)
    }
    
    ngOnChanges(changes: SimpleChanges) {
      if (changes._gameid) {
        this._gameid =  changes._gameid.currentValue as number;
        this.ngOnInit();
      }
    }
    
  ngOnInit(): void {
    this._sharedService.betSlipToggle = true;
    
    //this._lottoBetpanelService.clearallBetPanels();
    //this._sharedService.showContentLoader();
    this.error = new errorHelper();

    const loader = this.loadingCtrl.create({
      content: "Please Wait",
    });
      loader.present();

    if(this._gameid) {
      //get game definition.        
      this._lotteryService.getGameDefn(this._gameid)
        .subscribe(
        data => {
          // this._sharedService.hideContentLoader();
           loader.dismiss();
          window.scroll(0, 0);
          this._gameRule = new gamerule(data);
          if(this._gameRule.isRapid){
            if(!this.globalData.isfromrapid){
              this._lottoBetpanelService.clearallBetPanels();
            }
            this.globalData.isfromrapid = true;
          }else{
            if(this.globalData.isfromrapid){
              this._lottoBetpanelService.clearallBetPanels();
            }
            this.globalData.isfromrapid = false;
          }
          if(this._lotteryService.game && this._lotteryService.game.cgli && this._lotteryService.game.cgli[0].gstid==1)
            this._gameRule.pgn = this._lotteryService.game.gn;
          else
          this._gameRule.pgn ='';
          // this._sharedService.gameRule.next(this._gameRule);            
          if (this._gameRule) {
            //get drawlist                           
            this._sharedService.showContentLoader();
            this.drawsub = this._sharedService.getDrawListById(this._gameid).
              subscribe(data => {
              
                if (data.dli) {
                  this._gameRule.populateDraws(data.dli, this._sharedService.getServerTime());
                  if (this._gameRule.draws && this._gameRule.draws.length > 0)
                    this.drawex = this._gameRule.draws[0].did;
                  this._sharedService.hideContentLoader();
                  // console.log(this._gameRule);
                }
                else {
                  this._sharedService.hideContentLoader();
                  console.log('throw:  temprorily game not available');
                }
                //document.getElementById('next2').click();
              },
              error => {
                this._sharedService.hideContentLoader();
                console.log('throw:  temprorily game not available');
              });
            this.prizelevelsub = this._sharedService.getPrizeLevelList(this._gameid).
              subscribe(data => {
                if (data.pll) {
                  this._gameRule.populatePrizelevelLists(data.pll);
                  //this._sharedService.hideContentLoader();
                } else {
                  //this._sharedService.hideContentLoader();
                  console.log('throw:  temporarily prizes not available');
                }
              },
              error => {
                //this._sharedService.hideContentLoader();
                console.log('throw:  temporarily prizes not available');
              });
          }
        },
        error => {
          this._sharedService.hideContentLoader();
          console.log('throw:  temprorily game not available');
        });
    }
  }

  changeSelection(selection: selection) {
    try {
      this._gameRule.changeSelection(selection);
      let betPanel = new BetPanel();
      betPanel.did = this._gameRule.draws.find(a => a.isSelected).did;
      betPanel.gid = this._gameid
      betPanel.bid = this._gameRule.selectedBettype.bid;
      betPanel.betTypeName = this._gameRule.selectedBettype.btn;
      betPanel.gameName = this._gameRule.gn;
      betPanel.nofcomb = this._gameRule.selectedBettype.specialInfo.NoOfSets;
      this.flag = betPanel.foreignGames;

      if (this._gameRule.m2.length > 0) {
        // if (betPanel.m2.length <= this._gameRule.selectedBettype.m2)
        // betPanel.m2 = this._gameRule.m2.filter(a => a.isSelected == true && a.selTheme == numberType.plain).map(b => b.sid);
        var m2_sel = this._gameRule.m2.filter(a => a.isSelected == true && a.selTheme == numberType.plain).map(b => b.sid);
        if (m2_sel.length <= this._gameRule.selectedBettype.m2) {
          m2_sel.forEach(element => {
            betPanel.m2.push(element);
          });
        }
        betPanel.foreignGames = true;
        this._gameRule.foreignGames = true;
      } else {
        betPanel.m2 = this._gameRule.sel.filter(a => a.isSelected == true && a.selTheme == numberType.combination).map(b => b.sid);
        betPanel.foreignGames = false;
      }
      var selections = this._gameRule.sel.filter(a => a.isSelected == true && a.selTheme == numberType.plain)
      selections.forEach(element => {
        betPanel.sli.push(element.sid);
      });

      this._gameRule.bli.forEach(element => {
        this._gameRule._combinations = this.computeCombinations(element.m1, element.m2, betPanel);
        var num_diff = 0;
        var star_diff = 0;
        if (num_diff >= 0) {
          num_diff = element.m1 - betPanel.sli.length;
        }
        if (star_diff >= 0) {
          star_diff = element.m2 - betPanel.m2.length;
        }
        this._gameRule.selection_One = betPanel.sli.length;
        this._gameRule.selection_Two = betPanel.m2.length;
        this._gameRule._selectNumbers = num_diff;
        this._gameRule._selectStars = star_diff;
      });

    }
    catch (err) {
      this.toast.showError(err.message);
     // this.error.show = true;
      //this.error.message = err.message;
    }
  }

  addBetPanel() {
    try {
      this._gameRule.validateBet();
      let betPanel = new BetPanel();
      betPanel.did = this._gameRule.draws.find(a => a.isSelected).id;
      betPanel.drawNo = this._gameRule.draws.find(a => a.isSelected).did;
      betPanel.gid = this._gameid
      betPanel.bid = this._gameRule.selectedBettype.bid;
      betPanel.betTypeName = this._gameRule.selectedBettype.btn;
      betPanel.gameName = this._gameRule.gn;
      betPanel.cdt = new Date(this._gameRule.draws.find(a => a.isSelected).std);
      betPanel.minBetAmt = this.computeMinBetAmt(betPanel.bid);
      betPanel.sa = betPanel.minBetAmt;
      betPanel.pgn = this._gameRule.pgn;

          // check for double chance checkbox
      if (this._lotteryService.game) {
          betPanel.dc = 0;
          this._lotteryService.formulateExtrabetOption(this._lotteryService.game);
          console.log("extrabetOptions : ");
          console.log(this._lotteryService.extraBetOption);
      }

      if (this._gameRule.m2.length > 0) {
        betPanel.m2 = this._gameRule.m2.filter(a => a.isSelected == true && a.selTheme == numberType.plain).map(b => parseInt(b.sn));
        betPanel.foreignGames = true;
      } else {
        betPanel.m2 = this._gameRule.sel.filter(a => a.isSelected == true && a.selTheme == numberType.combination).map(b => b.sid);
        betPanel.foreignGames = false;
      }
      // betPanel.sli = this._gameRule.sel.filter(a => a.isSelected == true && a.selTheme == numberType.plain);
      var selections = this._gameRule.sel.filter(a => a.isSelected == true && a.selTheme == numberType.plain)
      selections.forEach(element => {
        betPanel.selectionObj.push(element);
        betPanel.sli.push(element.sid);
        // betPanel.sli.push(element.cl);
      });
      // var selections_m2 = this._gameRule.m2.filter(a => a.isSelected == true && a.selTheme == numberType.plain)
      // selections_m2.forEach(element => {
      //   betPanel.m2.push(element.sn);
      // });      
      
      this._gameRule.bli.forEach(element => {
        this._gameRule._combinations = this.computeCombinations(element.m1, element.m2, betPanel);
        //this._gameRule.minBet = element.minBet;
      });
      if (betPanel.foreignGames == false) {
        betPanel.nofcomb = this._gameRule.selectedBettype.specialInfo.NoOfSets;
      } else {
        betPanel.nofcomb = this._gameRule._combinations;
      }
      betPanel.noOfPanel = this._gameRule.spe.noofPanel;
     let j= this._lottoBetpanelService.lotteryBetSlip.betpanels.length;
     this._lottoBetpanelService.addBetPanel(betPanel);
      this._gameRule.reset();
      if(this._gameRule.selectedBettype && this._gameRule.selectedBettype != undefined){
        this._gameRule.selectedBettype = undefined;
      }
      this.bet_type = null;     
      this.bet_type_single = null;
      let b= this._lottoBetpanelService.lotteryBetSlip.betpanels.length;
        if(j==b){
          if(j == this._gameRule.spe.noofPanel){
            this.toast.showError("Panels count exceeded!");
          }else{
            this.toast.showError("Can not add different types of Bet");
          }
        }
    }
    catch (err) {
      this.toast.showError(err.message);
      this.error.show = true;
      // this.error.message = err;
      this._sharedService.toggle = true;
    }
  }

  private computeMinBetAmt(betTypeId: number): number {
    let retunMinBetAmt: number = 0;
    this._lottoBetpanelService._isMultiStakeBet = false;
    if (this._gameRule.bli) {
      for (let item of this._gameRule.bli) {
        if (item.minBet && item.minBet > 0) {
          this._lottoBetpanelService._isMultiStakeBet = true;
          break;
        }
      }
    }
    if (this._lottoBetpanelService._isMultiStakeBet) {
      let betTypeData = this._gameRule.bli.find(x => x.bid == betTypeId);
      if (betTypeData.minBet > 0)
        retunMinBetAmt = betTypeData.minBet;
      else
        retunMinBetAmt = this._gameRule.minbet;
    }
    else {
      retunMinBetAmt = this._gameRule.minbet;
    }
    return retunMinBetAmt;
  }

    /*Compute Combinations*/
    public computeCombinations(n: any, r: any, betPanel: any) {
      var selection_m1 = betPanel.sli.length;
      var selection_m2 = betPanel.m2.length;
      var result_m1 = (this.factorial(selection_m1) / (this.factorial(n) * this.factorial(selection_m1 - n)));
      var result_m2 = (this.factorial(selection_m2) / (this.factorial(r) * this.factorial(selection_m2 - r)));
  
      return result_m1 * result_m2;
    }

    public factorial(num: number): number {
      if (num == 1 || num == 0) {
        return 1;
      }
      if (num > 0)
        return num * this.factorial(num - 1);
    }

    // showerror(msg){
    //   let toast = this.toastCtrl.create({
    //     message: msg,
    //     duration: 1500,
    //     position: 'bottom'
    //   });

    //   toast.onDidDismiss(() => {
    //     console.log('Dismissed toast');
    //   });
    
    
    //   toast.present();
    // }
  
  //   loginClicked()
  // {
  //   let profileModal = this.modalCtrl.create(LoginModalPage);
  //   profileModal.present();    
  // }

  // registerClicked()
  // {
  //   let registerModal = this.modalCtrl.create(RegisterModalPage);
  //   registerModal.present();
  // } 
}



// WEBPACK FOOTER //
// ./src/app/lottery/lottery-detail/lottery-detail.ts